import { motion } from "framer-motion";
import { ArrowUpRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CONTACT_PHONE, CONTACT_PHONE_HREF } from "@/lib/api";

/** Breites Bildband mit Abschluss-CTA vor dem Kontaktformular. */
export default function CtaBand() {
  return (
    <section data-testid="cta-band" className="relative py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="relative rounded-[28px] overflow-hidden img-placeholder"
        >
          <img
            src="/images/cta-dorf.webp"
            alt="Luftaufnahme eines Schweizer Dorfes, dessen Hausdächer mit Solaranlagen belegt sind"
            width="2200"
            height="933"
            loading="lazy"
            decoding="async"
            className="w-full h-[380px] sm:h-[340px] md:h-[380px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1A1D20]/95 via-[#1A1D20]/75 to-[#1A1D20]/25" />

          <div className="absolute inset-0 flex items-center">
            <div className="p-7 sm:p-10 md:p-14 max-w-2xl">
              <div className="text-xs uppercase tracking-widest text-[#EAB308] font-semibold">
                Jedes Dach zählt
              </div>
              <h2 className="mt-3 font-display font-semibold text-white text-2xl sm:text-3xl md:text-4xl tracking-tight leading-tight">
                Ihr Dach produziert bereits Strom –
                <span className="text-white/65"> es fehlt nur die Anlage.</span>
              </h2>
              <p className="mt-4 text-white/75 text-sm sm:text-base max-w-lg leading-relaxed">
                Wir prüfen Ihr Dach kostenlos, berechnen den realistischen Ertrag
                und übernehmen den kompletten Förderantrag.
              </p>

              <div className="mt-7 flex flex-wrap gap-3">
                <Button
                  asChild
                  data-testid="ctaband-primary"
                  className="bg-[#EAB308] hover:bg-[#CA9A06] text-[#1A1D20] rounded-full h-12 px-6 font-semibold"
                >
                  <a href="#kontakt">
                    Kostenlose Dachprüfung <ArrowUpRight size={18} />
                  </a>
                </Button>
                <Button
                  asChild
                  variant="outline"
                  data-testid="ctaband-phone"
                  className="rounded-full h-12 px-6 bg-transparent border-white/30 text-white hover:bg-white hover:text-[#1A1D20]"
                >
                  <a href={CONTACT_PHONE_HREF}>
                    <Phone size={16} /> {CONTACT_PHONE}
                  </a>
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
